import { HIDE_BANNER } from './action-types';

export const hideBanner = () => ({
    type: HIDE_BANNER,
});
